// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__gMj6s","rootSuccess":"CompleteLink_rootSuccess__3xCf7","rootFailure":"CompleteLink_rootFailure__1-7SO","isDisabled":"CompleteLink_isDisabled__1BHz_"};